<template>
  <div v-if="show">
    <!-- header -->
    <meetingHeader :title="'会议室详情'" :right-show="true" @previewSwitch="previewSwitchFunc" />
    <!-- 当日预览 -->
    <div v-if="meetingShow">
      <!-- <div class="meeting-title">会议室当日使用情况</div> -->
      <meetingDay :meeting-data="meetingMouthData" @dialogshowFunc="dialogshowFunc" />
    </div>

    <!-- 月预览 -->
    <div v-show="!meetingShow">
      <div class="meeting-title">会议室当月使用情况</div>
      <mouthSelect ref="mouthSelect" :meeting-data="meetingAllData" @dialogshowFunc="dialogshowFunc" />
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogshow"
      show-cancel-button
      :show-confirm-button="true"
      :confirm-button-text="'预定'"
      :confirm-button-color="'#6488ff'"
      :cancel-button-text="'返回'"
      :cancel-button-color="'#6488ff'"
      @cancel="cancelfunc"
      @confirm="confirm"
    >
      <meetinDetailsList ref="Details" class="DetailsH" :meeting-data="meetingData" :time-date="timeDate" :time="true" />
    </van-dialog>
  </div>
</template>

<script>
import mouthSelect from '@/components/meeting/mouthSelect'
// import meetinDetails from '@/components/meeting/meetinDetails'
import meetingHeader from '@/components/meeting/meetingHeader'
import meetingDay from '@/components/meeting/meetingDay'
import meetinDetailsList from '@/components/meeting/meetinDetailsList'
import { GetMeeting } from '@/api/Meeting'
export default {
  name: 'Login',
  components: {
    mouthSelect,
    // meetinDetails,
    meetingHeader, meetingDay,
    meetinDetailsList },
  data() {
    return {
      show: false,
      // 模式切换  true 当月 false   当日
      meetingShow: false,
      // 弹窗
      dialogshow: false,
      // 查看详情 数据
      meetingData: [],
      meetingMouthData: [],
      // 所有数据
      meetingAllData: [],
      // 当前日期
      timeDate: ''
    }
  },
  watch: {
    meetingData: {
      handler(newVal, oldVal) {
        this.meetingDetails = newVal
        if (newVal !== oldVal && this.$refs.Details) {
          this.$refs.Details.bgNoneFunc()
        }
      },
      immediate: true
    }
  },
  created() {
    this.getAllMeetData()
  },
  mounted() {},
  methods: {
    async  getAllMeetData() {
      var _this = this
      var nowDate = _this.$moment(new Date()).format('YYYY-MM')
      await GetMeeting(function(res) {
        var resData = res.data
        if (res.code === 0) {
          _this.meetingMouthData = []
          resData.forEach(element => {
            var starTime = _this.$moment(element.meeting_time_s).format('YYYY-MM-DD HH:mm:ss')
            var endTime = _this.$moment(element.meeting_time_e).format('YYYY-MM-DD HH:mm:ss')
            var endTime1 = _this.$moment(element.meeting_time_e).format('HH:mm:ss')

            // var time2 = element.meeting_time_s.split(' ')[0] + ' 08:30:00'
            var time2 = starTime.split(' ')[0] + ' 08:30:00'
            var time1 = _this.computingTime(time2, starTime)
            var difference = _this.computingTime(starTime, endTime) * 60
            var colors = ''
            if (difference <= 60 && difference > 0) {
              colors = '#77e46c'
            } else if (difference > 60 && difference <= 120) {
              colors = '#7daaff'
            } else if (difference > 120 && difference <= 180) {
              colors = '#ffc87d'
            } else if (difference >= 180) {
              colors = '#ff7d7d'
            }

            _this.meetingMouthData.push({
              meeting_num: element.meeting_num,
              room_code: element.room_code,
              startime: starTime.split(' ')[0],
              starNum: Math.round(time1 * 60 / 15),
              color: colors,
              meeting_time_end: endTime1,
              meeting_title: element.meeting_title,
              roomName: '会议室' + element.room_code,
              register_name: element.user_name,
              stardate: starTime.split(' ')[1],
              endNum: Math.round(_this.computingTime(starTime, endTime) * 60 / 15 + time1 * 60 / 15)
            })
            var starMouth = _this.$moment(element.meeting_time_s).format('YYYY-MM-DD HH:mm:ss')
            if (_this.$moment(starMouth).isAfter(nowDate) || _this.$moment(starMouth).isSame(nowDate)) {
              _this.meetingAllData.push({
                meeting_num: element.meeting_num,
                room_code: element.room_code,
                startime: starTime.split(' ')[0],
                starNum: Math.round(time1 * 60 / 15),
                color: colors,
                meeting_time_end: endTime1,
                meeting_title: element.meeting_title,
                roomName: '会议室' + element.room_code,
                register_name: element.user_name,
                stardate: starTime.split(' ')[1],
                endNum: Math.round(_this.computingTime(starTime, endTime) * 60 / 15 + time1 * 60 / 15)
              })
            }
          })
        }
      })
      this.show = true
    },
    // 弹窗  点击确认按钮
    confirm() {
      this.$router.push({
        path: '/MeetingReservation',
        query: {
          type: 'mouth',
          data: this.meetingData,
          time: this.timeDate
        }
      })
    },
    // 预览模式切换
    previewSwitchFunc(val) {
      this.meetingShow = val
    },
    // 详情弹窗是否显示
    dialogshowFunc(val, tiem, data) {
      this.timeDate = tiem
      this.meetingData = data
      this.dialogshow = val
    },
    cancelfunc() {
      // this.meetingData = []
      // console.log(1)
      // this.$refs.Details.bgNoneFunc()
    },
    computingTime(dateS, dateE) {
      const t1 = this.$moment(dateS)
      const t2 = this.$moment(dateE)
      const dura = t2.format('x') - t1.format('x')
      const tempTime = this.$moment.duration(dura)
      var hours = tempTime.hours() + tempTime.minutes() / 60
      return hours
    }
  }
}
</script>
<style scoped>
.meeting-title{
    font-size: 15px;
    padding: 10px;
}
.DetailsH{
  max-height: 60vh;
  overflow: auto;
}
</style>
